//import 'react-app-polyfill/stable'
//import 'core-js'
import React from 'react'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import App from './App'
//import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
//import './i18n'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
      refetchInterval: 0,
    },
  },
})

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
